import * as types from './actionTypes';
import {store} from "../../App";

export function showToast(toastMessage){
  return {type: types.SHOW_TOAST, toastMessage}
}

export function dispatchShowToast(toastMessage) {
  store.dispatch(showToast(toastMessage));
}